export default {
    general: {
        add:         'Add',
        edit:        'Edit',
        cancel:      'Cancel',
        save:        'Save',
        close:       'Close',
        confirm:     'Confirm',
        loading:     'Loading…',
        logout:      'Log out',
        email:       'Email',
        theme:       'Toggle theme',
        retry:       'Retry',
        all:         'All',
        clear:       'Clear',
        none:        'None',
        back:        'Back',
        view:        'View',
        actions:     'Actions',
        inactive:    'Inactive',
        venue:       'Venue',
        reference:   'Reference',
        optional:    'Optional',
        no_results:  'No results',
    },
    errors: {
        generic_error:      'An error occurred',
        invalid_data:       'Invalid data',
        not_found:          'Not found',
        unauthorized:       'Your session has expired. Please sign in again.',
        conflict:           'That value is already in use.',
        not_reversible:     'This entry cannot be reversed.',
        insufficient_funds: 'Insufficient funds.',
        forbidden:          'You do not have permission for this action.',
        on_add:             'Error while adding',
        on_edit:            'Error while updating',
        on_fund:            'Error while adding funds',
        on_charge:          'Error while charging',
    },
    success: {
        add:          'Successfully added',
        edit:         'Successfully updated',
        rfid_changed: 'RFID updated',
    },
    auth: {
        sign_in:            'Sign in',
        sign_in_subtitle:   'Sign in to your Imprion Cashless account.',
        username:           'Username',
        password:           'Password',
        login_failed:       'Incorrect username or password.',
        select_client:      'Select a client',
        select_client_hint: 'Choose which client you want to operate.',
        no_clients:         'You are not assigned to any client yet.',
        load_clients_error: 'Could not load your clients.',
        select_failed:      'Could not select that client.',
        continue:           'Continue',
    },
    nav: {
        dashboard:   'Dashboard',
        holders:     'Holders',
        ledger:      'Ledger',
        value_types: 'Value types',
        venues:      'Venues',
        devices:     'Devices',
        open_menu:     'Open menu',
        account:       'Account',
        client:        'Client',
        switch_client: 'Switch client',
    },
    table: {
        total: '{total} total',
    },
    dashboard: {
        title:           'Dashboard',
        welcome:         'Welcome back',
        placeholder:     'Manage holders, funding, and the ledger for your venue.',
        holders_desc:    'Issue, fund, and manage holders and their cards.',
        ledger_desc:     'Browse and export every transaction.',
        outstanding:     'Outstanding by value type',
        no_totals:       'No balances yet.',
        charge_volume:   'Charge volume by venue',
        no_volume:       'No venue-attributed charges yet.',
        recent_activity: 'Recent activity',
        no_activity:     'No transactions yet.',
    },
    value_type: {
        value_types:    'Value types',
        subtitle:       'Define the balance types holders can carry and spend.',
        add:            'Add value type',
        edit:           'Edit value type',
        code:           'Code',
        code_hint:      'Uppercase letters, digits, and underscore (immutable).',
        name:           'Name',
        max_decimals:   'Max decimals',
        overdraft:      'Overdraft limit',
        active:         'Active',
        empty:          'No value types yet. Add one to start funding holders.',
        guard_title:    'Cannot lower precision',
        guard_message:  'Lowering max decimals would strand these holders\' balances. Adjust them first, then retry.',
        holder:         'Holder',
        balance:        'Balance',
    },
    venue: {
        venues:          'Venues',
        subtitle:        'The physical sites where devices operate.',
        add:             'Add venue',
        edit:            'Edit venue',
        name:            'Name',
        status:          'Status',
        status_active:   'Active',
        status_archived: 'Archived',
        empty:           'No venues yet. Add one to register devices against it.',
    },
    device: {
        devices:         'Devices',
        subtitle:        'Integration devices (PoS terminals, readers) and their keys.',
        register:        'Register device',
        name:            'Name',
        status:          'Status',
        status_active:   'Active',
        status_revoked:  'Revoked',
        last_seen:       'Last seen',
        never:           'Never',
        empty:           'No devices yet. Register one to issue its API key.',
        tab_active:      'Active',
        tab_revoked:     'Revoked',
        no_active:       'No active devices.',
        key_title:       'Device registered',
        key_warning:     'Copy this API key now — it is shown once and cannot be retrieved again.',
        copy:            'Copy',
        copied:          'Copied',
        done:            'Done',
        revoke:          'Revoke',
        confirm_revoke:  'Revoke this device? Its key will stop working immediately.',
        revoked:         'Device revoked',
    },
    holder: {
        holders:        'Holders',
        subtitle:       'Issue, fund, and manage holders and their cards.',
        holder:         'Holder',
        add:            'Add holder',
        edit:           'Edit holder',
        uuid:           'UUID',
        rfid:           'RFID',
        name:           'Name',
        status:         'Status',
        status_active:  'Active',
        status_blocked: 'Blocked',
        balances:       'Balances',
        no_balances:    'No balances yet',
        recent_activity:'Recent activity',
        anonymous:      'Anonymous',
        change_rfid:    'Change RFID',
        new_rfid:       'New RFID',
        fund:           'Add funds',
        charge:         'Charge',
        block:          'Block',
        unblock:        'Unblock',
        confirm_block:  'Block this holder? They will not be able to spend or be funded until unblocked.',
        empty:          'No holders yet. Add one to get started.',
        created:        'Created',
    },
    funding: {
        title:       'Add funds',
        value_type:  'Value type',
        amount:      'Amount',
        external_id: 'External ID',
        new_balance: 'New balance: {balance}',
    },
    charge: {
        title:       'Charge holder',
        charge:      'Charge',
        new_balance: 'Charged. New balance: {balance}',
    },
    transfer: {
        title:              'Transfer',
        from:               'From',
        to:                 'Recipient',
        search_placeholder: 'Search by name or RFID',
        no_matches:         'No holders match',
        transfer:           'Transfer',
        success:            'Transfer complete',
    },
    reverse: {
        title:       'Reverse entry',
        original:    'Reversing',
        reverse:     'Reverse',
        success:     'Entry reversed',
    },
    ledger: {
        ledger:          'Ledger',
        subtitle:        'Every transaction across all holders.',
        kind:            'Kind',
        value_type:      'Value type',
        holder:          'Holder',
        date:            'Date',
        amount:          'Amount',
        actor:           'Actor',
        external_id:     'External ID',
        export:          'Export CSV',
        empty:           'No transactions match these filters.',
        kind_funding:    'Funding',
        kind_spend:      'Spend',
        kind_reversal:   'Reversal',
        kind_adjustment: 'Adjustment',
        kind_transfer:   'Transfer',
    },
    app: {
        name: 'Imprion Cashless',
    },
}
